<script>
export default {
    props: {
        variant: String,
        title: String,
        onClick: Function,
        classes: String,
        disabled: Boolean,
        type: String,
        title: String
    },
};
</script>

<template>
    <button
        :type="type"
        :class="classes"
        :disabled="disabled"
        :title="title"
        @click="onClick()"
    >
        <slot />
    </button>
</template>